// extracted by mini-css-extract-plugin
module.exports = {"btn":"TopBarBtn_btn__2An3N","icon":"TopBarBtn_icon__1ASqg","text":"TopBarBtn_text__3A3O6"};